export const TYPE_OPTIONS = [
    { label: 'All', value: 'all' },
    { label: 'Payment', value: 'payment' },
    { label: 'Credit', value: 'credit payment' },
    { label: 'Adjustment', value: 'adjustment' },
    { label: 'Fee', value: 'fee' },
    { label: 'Rounding Adjustment', value: 'rounding adjustment' },
];

export const STATUS_OPTIONS = [
    { label: 'All', value: 'all' },
    { label: 'Completed', value: 'completed' },
    { label: 'Pending', value: 'pending' },
    { label: 'Voided', value: 'voided' },
    { label: 'Skipped', value: 'skipped' },
    { label: 'Not Found', value: 'not found' },
];

export const MARKETPLACE_OPTIONS = [
    { label: 'All', value: 'all' },
    { label: 'Automatiq B2B', value: 'automatiq_b2b' },
    { label: 'Vivid Seats', value: 'vividseats' },
    { label: 'Seat Geek', value: 'seat_geek' },
    { label: 'Fanxchange', value: 'fanxchange' },
    { label: 'Gametime', value: 'gametime' },
    { label: 'StubHub', value: 'stubhub' },
    { label: 'Ticket Evolution', value: 'ticket_evolution' },
    { label: 'Ticketmaster', value: 'ticketmaster' },
    { label: 'Ticket Monster', value: 'ticket_monster' },
    { label: 'Ticketnetwork', value: 'ticketnetwork' },
    { label: 'Ticketnetwork Mercury', value: 'ticketnetwork_mercury' },
    { label: 'Tickpick', value: 'tickpick' },
    { label: 'Viagogo', value: 'viagogo' },
    { label: 'Other', value: 'other' },
];
